/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */

/**
 * Created by jessenelson on 3/31/15.
 */
'use strict';
angular.module('prism-ui.components.data').factory('PackageResourceFactory',
    function ($resource, EndPointService) {

        return $resource(EndPointService.packageEndPoint + '/:id' + '/:sub', {
                fetchOffset: '@fetchOffset',
                fetchLimit: '@limit',
                searchString: '@searchString',
                id: '@id',
                sub: '@sub',
                includeHidden: '@includeHidden',
                numberOfPackages: '@numberOfPackages',
                view: '@view',
                lock: '@lock',
                mapId: '@mapId',
                forceRefresh: '@forceRefresh'
            },
            {
                query: {
                    method: 'GET',
                    isArray: true,
                    cancellable: true
                },
                get: {
                    method: 'GET',
                    isArray: false,
                    cancellable: true
                },
                save: {
                    method: 'POST',
                    isArray: false
                },
                saveCollaborators: {
                    method: 'POST',
                    isArray: true
                },
                savePartnerPackages: {
                    method: 'PUT',
                    isArray: true
                },
                findRelatedItems: {
                    method: 'GET',
                    url: EndPointService.packageEndPoint + '/:id' + '/relatedMedia',
                    params: {
                        videoPath: '@path', acceptTemplateMemberId: '@acceptTemplateMemberId'
                    },
                    isArray: true
                },
                completedDeliveries: {
                    method: 'GET',
                    url: EndPointService.packageEndPoint + '/:id' + '/completedDeliveries',
                    params: {
                        excludePreDeliveries: '@excludePreDeliveries'
                    },
                    isArray: true
                },
                saveMetadata: {
                    method: 'PUT',
                    url: EndPointService.packageEndPoint + '/:id' + '/metadata',
                    isArray: false
                },
                toggleArchive: {
                    method: 'DELETE',
                    url: EndPointService.packageEndPoint + '/:id',
                    isArray: false
                },
                clone: {
                    method: 'PUT',
                    url: EndPointService.packageEndPoint + '/:id',
                    isArray: false
                },
                getClips: {
                    method: 'GET',
                    url: EndPointService.packageEndPoint + '/:id' + '/clips',
                    params: {
                        includeHidden: '@includeHidden'
                    },
                    isArray: true
                },
                saveArtwork: {
                    method: 'POST',
                    isArray: true,
                    url: EndPointService.packageEndPoint + '/:id' + '/artworkAssets'
                },
                removeLock: {
                    method: 'DELETE',
                    url: EndPointService.packageEndPoint + '/locks/:id',
                    isArray: false
                },
                validatePackages: {
                    method: 'PUT',
                    url: EndPointService.packageEndPoint + '/validate',
                    isArray: false
                },
                executeSearchFilter: {
                    method: 'POST',
                    url: EndPointService.packageEndPoint + '/searches',
                    isArray: true
                },
                getCategories: {
                    method: 'GET',
                    url: EndPointService.packageEndPoint + '/categoryTypes',
                    params: {
                        view: '@view'
                    },
                    isArray: true
                },
                getTimings: {
                    method: 'GET',
                    url: EndPointService.packageEndPoint + '/:id/timings',
                    isArray: false
                },
                saveTiming: {
                    method: 'PUT',
                    isArray: false,
                    url: EndPointService.packageEndPoint + '/:id/timings'
                },
                uploadTimings: {
                    method: 'PUT',
                    isArray: false,
                    url: EndPointService.packageEndPoint + '/:id/importTimings'
                },
                acceptPackage: {
                    method: 'PUT',
                    isArray: false,
                    url: EndPointService.packageEndPoint + '/:id/accept'
                },
                rejectPackage: {
                    method: 'PUT',
                    isArray: false,
                    params: {
                        reason: '@reason'
                    },
                    url: EndPointService.packageEndPoint + '/:id/reject'
                },
                resetPackages: {
                    method: 'PUT',
                    url: EndPointService.packageEndPoint + '/reset',
                    isArray: false
                },
                deliveryWorkflows: {
                    method: 'GET',
                    url: EndPointService.packageEndPoint + '/:id/deliveryWorkflows',
                    params: {
                        includeClips: '@includeClips'
                    },
                    isArray: true
                },
                getClipAcceptTemplateMembers: {
                    method: 'GET',
                    url: EndPointService.packageEndPoint + '/:id/clipAcceptTemplateMembers',
                    isArray: true
                },
                checkIn: {
                    method: 'PUT',
                    url: EndPointService.checkInEndpoint,
                    isArray: true,
                },
                getExternalIngests: {
                    method: 'GET',
                    params: {
                        packageId: '@packageId'
                    },
                    url: `${EndPointService.packageEndPoint}/:packageId/externalIngests`,
                    isArray: true
                }
            }
        );
    });
